import React, { useEffect } from 'react';

import Navbar from '../components/common/Navbar';
import Footer from '../components/common/Footer';
import Logo from '../components/common/Logo';
import Article from '../components/articles/Article';

import INFO from '../data/user';
import myArticles from '../data/article';

import './styles/articles.css';

const Articles = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <div className="page-content">
        <Navbar active="articles" />
        <div className="content-wrapper">
          <div className="articles-logo-container">
            <div className="articles-logo">
              <Logo width={46} />
            </div>
          </div>

          <div className="articles-main-container">
            <div className="title articles-title">
              {INFO.articles.title}
            </div>

            <div className="subtitle articles-subtitle">
              {INFO.articles.description}
            </div>

            <div className="articles-container">
              <div className="articles-wrapper">
                {myArticles.map((article, index) => (
                  <div
                    className="articles-article"
                    key={(index + 1).toString()}
                  >
                    <Article
                      key={(index + 1).toString()}
                      date={article().date}
                      title={article().title}
                      description={article().description}
                      link={article().link}
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="page-footer">
            <Footer />
          </div>
        </div>
      </div>
    </>
  );
};

export default Articles;
